import React from 'react';

import { Body, Title } from '@icarros/ids-react';
import { ReactComponent as NoResults } from '../../../assets/rebranding/feedback/empty-spaces/sem-resultados.svg';

import { ResultsNotFoundWrapper } from './style';

export function ResultsNotFound(): JSX.Element {
  return (
    <ResultsNotFoundWrapper>
      <NoResults />
      <Title contrast="light">o termo não foi encontrado</Title>
      <Body size="body_1" contrast="default">
        Você pode tentar buscar por um novo termo ou tentar selecionar alguma das opções indicadas
      </Body>
    </ResultsNotFoundWrapper>
  );
}
